<template>
    <div>
        <SkeletonBase
            :content="1"
            has-divided
        />
        <SkeletonBase
            has-title
            :content="2"
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
